let selectedClinic = null;
window.clinics = []; // Definir globalmente para acceso en otras funciones

// Función para calcular la distancia usando la fórmula del Haversine
function calcularDistancia(lat1, lon1, lat2, lon2) {
    const R = 6371; // Radio de la Tierra en km
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a =
        0.5 - Math.cos(dLat) / 2 +
        Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
        (1 - Math.cos(dLon)) / 2;
    return R * 2 * Math.asin(Math.sqrt(a));
}

// Función para sugerir clínicas cercanas basadas en la ubicación del usuario
function sugerirClinicasCercanas() {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
            const userLat = position.coords.latitude;
            const userLon = position.coords.longitude;
            console.log(`Usuario en: ${userLat}, ${userLon}`);

            // Verificar si clinics está disponible
            if (window.clinics.length === 0) {
                console.error('No hay clínicas disponibles para sugerir.');
                mostrarMensajeErrorGeolocalizacion();
                return;
            }

            // Calcular la distancia entre el usuario y cada clínica
            window.clinics.forEach(clinic => {
                const distancia = calcularDistancia(userLat, userLon, parseFloat(clinic.ClinicLatitude), parseFloat(clinic.ClinicLongitude));
                clinic.distancia = distancia;
                console.log(`Distancia a ${clinic.ClinicName}: ${distancia.toFixed(2)} km`);
            });

            // Ordenar clínicas por distancia
            window.clinics.sort((a, b) => a.distancia - b.distancia);

            // Mostrar las clínicas más cercanas o preseleccionar la más cercana
            const clinicList = document.getElementById('clinicList');
            clinicList.innerHTML = '';

            if (window.clinics.length === 0) {
                const noResultsMessage = document.createElement('li');
                noResultsMessage.textContent = "No existe Clínica en esta comuna o ciudad, intenta con otro lugar cercano.";
                clinicList.appendChild(noResultsMessage);
            } else {
                window.clinics.forEach(clinic => {
                    const li = document.createElement('li');
                    li.innerHTML = `${clinic.ClinicName} <span>${clinic.ClinicAppAddress1}</span>`;
                    li.dataset.code = clinic.ClinicID;

                    li.onclick = () => {
                        console.log('Clinic list item clicked', clinic);
                        selectClinic(clinic);
                    };

                    clinicList.appendChild(li);
                });
            }

            console.log('Clínicas sugeridas por proximidad:', window.clinics);
            clinicList.style.display = 'block';
        }, function (error) {
            console.error('Error al obtener la geolocalización:', error);
            mostrarMensajeErrorGeolocalizacion();
        });
    } else {
        console.error('Geolocalización no soportada por el navegador');
        mostrarMensajeErrorGeolocalizacion();
    }
}

function mostrarMensajeErrorGeolocalizacion() {
    const clinicList = document.getElementById('clinicList');
    clinicList.innerHTML = '<li>No se pudo obtener tu ubicación. Intenta ingresar tu ciudad o comuna manualmente.</li>';
    clinicList.style.display = 'block';
}

// Función para obtener clínicas
async function fetchClinics() {
    try {
        const response = await fetch('https://belenus-shopify-app-2kc8s.ondigitalocean.app/api/clinics');
        if (!response.ok) {
            throw new Error(`Error: ${response.statusText}`);
        }
        const clinics = await response.json();
        return clinics;
    } catch (error) {
        console.error('Error fetching clinics:', error);
        return [];
    }
}

// Inicializar clínicas y sugerir clínicas cercanas
async function initializeClinics() {
    window.clinics = await fetchClinics();
    console.log('Fetched clinics:', window.clinics);
    sugerirClinicasCercanas();
}

// Llamar a la función para inicializar clínicas
initializeClinics();

function setupFilterClinics() {
    const inputField = document.getElementById('cityOrComuna');
    console.log("inputField: ", inputField);

    // Prevenir espacios como primer carácter
    inputField.addEventListener('input', (event) => {
        // Eliminar espacios al principio
        event.target.value = event.target.value.replace(/^\s+/g, '');
        filterClinics();
    });

    // Seleccionar la primera opción al presionar Enter
    inputField.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            const firstOption = document.querySelector('#clinicList li');
            if (firstOption) {
                firstOption.click();
            }
        }
    });
}

function filterClinics() {
    console.log('filterClinics called');
    const query = document.getElementById('cityOrComuna').value.toLowerCase().trim();
    console.log('Query:', query);
    const clinicList = document.getElementById('clinicList');
    console.log('Clinic list element:', clinicList);
    clinicList.innerHTML = '';  // Limpiar la lista de resultados

    if (query === '') {
        // Mostrar todas las clínicas si el input está vacío (sin espacios iniciales)
        window.clinics.forEach(clinic => {
            const li = document.createElement('li');
            li.innerHTML = `${clinic.ClinicName} <span>${clinic.ClinicAppAddress1}</span>`;
            li.dataset.code = clinic.ClinicID;

            li.onclick = () => {
                console.log('Clinic list item clicked', clinic);
                selectClinic(clinic);
            };

            clinicList.appendChild(li);
        });
        clinicList.style.display = 'block';
        return;
    }

    // Filtrar las clínicas por coincidencia en los campos relevantes
    const filteredClinics = clinics.filter(clinic =>
        clinic.ClinicCity.toLowerCase().includes(query) ||
        clinic.ClinicAppAddress1.toLowerCase().includes(query) ||
        clinic.ClinicAppAddress2?.toLowerCase().includes(query) ||  // Incluye address2 si existe
        clinic.ClinicAppAddress3?.toLowerCase().includes(query) ||  // Incluye address3 si existe
        clinic.ClinicName.toLowerCase().includes(query) ||
        clinic.ClinicCommercialName?.toLowerCase().includes(query)  // Incluye ClinicCommercialName si existe
    );
    console.log('Filtered clinics:', filteredClinics);

    if (filteredClinics.length === 0) {
        // Si no hay clínicas que coincidan con el filtro, mostrar un mensaje
        const noResultsMessage = document.createElement('li');
        noResultsMessage.style.fontSize = '14px';
        noResultsMessage.style.color = 'grey';
        noResultsMessage.style.cursor = 'pointer';

        noResultsMessage.innerHTML = `
            <i class="fas fa-exclamation-circle" style="margin-right: 8px;"></i>
            No existe Clínica que coincida con la búsqueda, intenta con otro criterio.
        `;

        noResultsMessage.addEventListener('click', function() {
            const cityOrComunaInput = document.getElementById('cityOrComuna');
            cityOrComunaInput.focus();
            cityOrComunaInput.value = ''; // Limpiar el contenido del input
        });

        clinicList.appendChild(noResultsMessage);
        console.log('Displayed no results message');
    } else {
        // Si se encuentra una coincidencia exacta, mostrar también clínicas cercanas
        const exactMatchClinic = filteredClinics[0];

        // Calcular la distancia desde la clínica exacta a otras clínicas
        window.clinics.forEach(clinic => {
            clinic.distancia = calcularDistancia(
                parseFloat(exactMatchClinic.ClinicLatitude),
                parseFloat(exactMatchClinic.ClinicLongitude),
                parseFloat(clinic.ClinicLatitude),
                parseFloat(clinic.ClinicLongitude)
            );
        });

        // Ordenar clínicas por distancia
        const nearbyClinics = window.clinics.sort((a, b) => a.distancia - b.distancia);

        // Mostrar la clínica exacta y las cercanas
        const clinicsToShow = [exactMatchClinic, ...nearbyClinics.filter(clinic => clinic !== exactMatchClinic)];

        clinicsToShow.forEach(clinic => {
            console.log('Processing clinic:', clinic);
            const li = document.createElement('li');
            li.innerHTML = `${clinic.ClinicName} <span>${clinic.ClinicAppAddress1}</span>`;
            li.dataset.code = clinic.ClinicID;

            li.onclick = () => {
                console.log('Clinic list item clicked', clinic);
                selectClinic(clinic);
            };

            clinicList.appendChild(li);
        });
    }

    console.log('Finished processing filtered clinics');
    clinicList.style.display = 'block';
    console.log('Set clinicList display to block');
}

// Asegurar que el input pueda seguir siendo utilizado después de mostrar resultados
setupFilterClinics();

// Si es necesario, asegúrate de que setupFilterClinics se ejecute después de DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
    initializeClinics();
    setupFilterClinics();
});

function selectClinic(clinic) {
    console.log('selectClinic called', clinic);
    selectedClinic = clinic;
    const selectedClinicDiv = document.getElementById('selectedClinic');
    const inputField = document.getElementById('cityOrComuna');
    selectedClinicDiv.innerHTML = `Reserva tu próxima sesión de regalo en: ${clinic.ClinicCommercialName}, ${clinic.ClinicAddress}`;
    inputField.style.display = 'none';
    document.getElementById('clinicList').style.display = 'none';

    // Añadir datos de la clínica seleccionada al objeto collectedData
    collectedData.clinic = {
        city: clinic.ClinicCity,
        name: clinic.ClinicName,
        address: clinic.ClinicAppAddress1,
        address2: clinic.ClinicAppAddress2,
        address3: clinic.ClinicAppAddress3,
        code: clinic.ClinicID,
        latitude: clinic.ClinicLatitude,
        longitude: clinic.ClinicLongitude,
        timeStart: clinic.ClinicTimeStart,
        timeEnd: clinic.ClinicTimeEnd
    };

    console.log('Datos asignados a collectedData.clinic:', collectedData.clinic);

    // Inserta el embed tradicional de Google Maps en el div 'clinicMap'
    const clinicMapDiv = document.getElementById('clinicMap');
    const name = encodeURIComponent(clinic.ClinicName); // Encodes the clinic name for URL
    const mapUrl = `https://www.google.com/maps?q=${name}@${clinic.ClinicLatitude},${clinic.ClinicLongitude}&hl=es&z=15&output=embed`;
    clinicMapDiv.innerHTML = `<iframe width="100%" height="300" frameborder="0" style="border:0; border-radius:10px" src="${mapUrl}" allowfullscreen></iframe>`;
    showCalendar();
}


function editClinicSelection() {
    const button = document.getElementById('editClinicButton');
    
    // Verificar si el botón está habilitado usando el atributo `data-enabled`
    if (button.getAttribute('data-enabled') === 'false') {
        console.log('El botón está deshabilitado, no se ejecuta la función.');
        return;  // Detenemos la ejecución de la función si el botón está deshabilitado
    }

    // Si el botón está habilitado, ejecutar la lógica normal
    console.log('editClinicSelection called');
    
    // Ocultar el calendario y mostrar la selección de clínica
    document.getElementById('calendar-container').style.display = 'none';
    document.getElementById('clinic-selection').style.display = 'block';
    
    // Ajustar la barra de progreso en el timeline
    document.querySelector('.timeline li:nth-child(2)').classList.add('active');
    document.querySelector('.timeline li:nth-child(3)').classList.remove('active');

    // Resetear los campos de la selección de clínica
    const inputField = document.getElementById('cityOrComuna');
    inputField.style.display = 'block';
    inputField.value = '';

    document.getElementById('clinicList').style.display = 'block';
    document.getElementById('clinicList').innerHTML = '';  // Limpiar la lista de clínicas
    document.getElementById('selectedClinic').innerHTML = '';  // Limpiar la clínica seleccionada
    document.getElementById('selectedClinicCalendar').style.display = 'none';  // Ocultar el calendario de la clínica seleccionada
    
    console.log('Clinic selection reset');
}


// Inicializar la carga de clínicas al cargar la página
document.addEventListener('DOMContentLoaded', initializeClinics);
